module.exports = __webpack_public_path__ + "img/main-2 copy.40a6f902.webp";